import { useSelector } from 'react-redux';
import { getBankruptcyForm } from '../pages/create-notice/utilities/utils';
import { RootState } from '../store/store';
import { useCallback, useMemo } from 'react';
import { createSchema, debtor341SchemaCorporation } from '../utils/validations';
import { AnyObject, object, ObjectSchema } from 'yup';

const use341SpecialRules = () => {
  const caseConvertedChapter = useSelector(
    (state: RootState) => state.upload.formData.caseConvertedChapter,
  );

  const caseChapter = useSelector(
    (state: RootState) => state.upload.formData.caseChapter,
  );

  const proofOfClaim = useSelector(
    (state: RootState) => state.upload.formData.proofOfClaim,
  );

  const subChapterV = useSelector(
    (state: RootState) => state.upload.formData.subChapterV,
  );

  const bankruptcyType = useSelector(
    (state: RootState) => state.upload.formData.bankruptcyType,
  );

  const selectedChapter = caseConvertedChapter || caseChapter;

  const bk341FormType = useMemo(
    () =>
      getBankruptcyForm(
        bankruptcyType,
        selectedChapter,
        proofOfClaim,
        subChapterV,
      ),
    [bankruptcyType, selectedChapter, proofOfClaim, subChapterV],
  );

  const getSpecial341Schema = (
    bk341FormType: string,
  ): ObjectSchema<AnyObject> => {
    switch (bk341FormType) {
      case '309D':
        return createSchema([
          'creditorsProofOfClaim',
          'governmentProofOfClaim',
        ]);
      case '309B':
        return createSchema([
          'presumptionOfAbuse',
          'dischargeable',
          'creditorsProofOfClaim',
          'governmentProofOfClaim',
        ]);
      case '309A':
        return createSchema(['presumptionOfAbuse', 'dischargeable']);
      case '309E1':
      case '309E2':
        return createSchema(['dischargeable', 'deadlineProofOfClaimSelected', 'deadlineForFillingProofOfClaimSpecial'])
      case '309F1':
      case '309F2':
        return createSchema(['deadlineProofOfClaimSelected', 'deadlineForFillingProofOfClaimSpecial'])
      case '309G':
      case '309H':
      case '309I':
        return createSchema(['fillingPlanSelected', 'dischargeable', 'creditorsProofOfClaim', 'governmentProofOfClaim', 'hearingDate', 'hearingTime', 'hearingLocation'])
      // Handle other cases or default
      default:
        return object(); // Default empty schema
    }
  };

  const shouldHideTrustee = useMemo(() => {
    const is309E1 = bk341FormType === '309E1';
    const is309F1 = bk341FormType === '309F1';

    return is309E1 || is309F1;
  }, [bk341FormType]);

  const isCorporate = bankruptcyType === 'Corporation or Partnership';

  return { shouldHideTrustee, isCorporate, bk341FormType, getSpecial341Schema };
};

export default use341SpecialRules;
